// File: frontend/src/components/GDPRConsent/PolicyContents/TermsOfServiceContent.js

import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import styles from './PolicyContent.module.css';

const TermsOfServiceContent = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.policyContainer}>
      <h1>{t('conditions_of_use_title', 'Terms of Service')}</h1>
      <p className={styles.lastUpdated}>{t('conditions_of_use_last_updated', 'Last Updated: January 1, 2023')}</p>
      <p className={styles.effectiveDate}>{t('conditions_of_use_effective_date', 'Effective Date: January 15, 2023')}</p>

      <section className={styles.section}>
        <p>{t('conditions_of_use.introduction', 'These Terms of Service govern your use of our website and services. By accessing or using our services, you agree to be bound by these Terms.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.services_description', 'Services Description')}</h2>
        <p>{t('conditions_of_use.services_description_content', 'We provide a platform for insurance technology solutions, including risk assessment, analytics, and policy management tools.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.account_creation_and_use', 'Account Creation and Use')}</h2>
        <p>{t('conditions_of_use.account_creation_and_use_content', 'To access certain features, you may need to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.data_collection_and_use', 'Data Collection and Use')}</h2>
        <p>{t('conditions_of_use.data_collection_and_use_content', 'Our collection and use of your information is governed by our Privacy Policy. By using our services, you consent to our data practices as described in the Privacy Policy.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.user_responsibilities', 'User Responsibilities')}</h2>
        <p>{t('conditions_of_use.user_responsibilities_content', 'You agree to use our services only for lawful purposes and in accordance with these Terms. You are responsible for ensuring that your use of the services complies with all applicable laws and regulations.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.intellectual_property_rights', 'Intellectual Property Rights')}</h2>
        <p>{t('conditions_of_use.intellectual_property_rights_content', 'Our services and content are protected by copyright, trademark, and other intellectual property laws. You may not use, reproduce, or distribute our content without our permission.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.limitation_of_liability', 'Limitation of Liability')}</h2>
        <p>{t('conditions_of_use.limitation_of_liability_content', 'To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of our services.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('conditions_of_use.contact_information', 'Contact Information')}</h2>
        <p>{t('conditions_of_use.contact_information_content', 'If you have any questions about these Terms, please contact us at terms@example.com.')}</p>
      </section>
    </div>
  );
};

export default TermsOfServiceContent;